const initialState = {
    userToken : {},
    userInfo : {},
    tauxProduits: [],
    showNewInstitutionCategory: false,
    showNewProductCategory: false,
    showNewProduct: false,
    showDeleteConfirmation: false,
    currentInstitutionCategory: { id: null, libelle: null },
    currentProductCategory: { id: null, libelle: null },
    currentProduct: {},
    menuSettingsShow: false,
    menuMonitoringShow: false,
    blockOrUnblockModal: "",
    breadcrumbContent: {
        firstLevelText: "", firstLevelLink: "", secondLevelText: "", secondLevelLink: "", thirdLevelText: "", thirdLevelLink: ""
    }
};
function rootReducer(state = initialState, action) {
    if (!state) {

        return null;
    } else {
        // console.log(action)
        return { ...state, [action.key]: action.payload };
    }
}
export default rootReducer;